<script setup lang="ts"></script>
<template>
  <h3 class="font-semibold tracking-tighter text-gray-900 xs:text-4xl lg:text-5xl">
    <slot></slot>
  </h3>
</template>
